/* eslint-disable */
export const mainPageEn = {
  'Boards': 'Boards',
};

export const mainPageRu = {
  'Boards': 'Доски',
};
/* eslint-disable */